import { API_ROUTE } from "../constants/workerConstants";
import AxiosInstance from "./http.handlers";

export const GetInvPartCategoryTypes = async (headers) => {
  return await AxiosInstance.get(`${API_ROUTE.InvPartCategoryType.CRUD}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const CreateInvPartCategoryType = async (payload, headers) => {
  return await AxiosInstance.post(
    `${API_ROUTE.InvPartCategoryType.CRUD}`,
    payload,
    {
      headers, 
    }
  )
    .then((response) => response)
    .catch((error) => error);
};

export const GetInvPartCategoryType = async (id, headers) => {
  return await AxiosInstance.get(`${API_ROUTE.InvPartCategoryType.CRUD}/${id}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const updateInvPartCategoryType = async (id, payload, headers) => {
  return await AxiosInstance.put(
    `${API_ROUTE.InvPartCategoryType.CRUD}/${id}`,
    payload,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};
